<div class="configuration-container">
  <p-card header="Order Management Configuration">
    @if (isLoading()) {
      <div class="loading">
        <p-progressSpinner strokeWidth="4" />
      </div>
    } @else {
      <p class="secondary-text">Cart reservation settings for Schedule Ahead &amp; Save. Times are in whole minutes.</p>

      <div class="field">
        <label for="cartReservationWindowMinutes">Reservation Window (minutes)</label>
        <p-inputNumber
          data-testid="orders-config-window"
          inputId="cartReservationWindowMinutes"
          [min]="1"
          [max]="1440"
          [maxFractionDigits]="0"
          [showButtons]="true"
          [ngModel]="configForm.cartReservationWindowMinutes().value()"
          (ngModelChange)="configForm.cartReservationWindowMinutes().value.set($event)"
        />
        <small class="help-text">How long a cart holds its reservation from the first item (or an extend).</small>
        @if (
          configForm.cartReservationWindowMinutes().touched() && !configForm.cartReservationWindowMinutes().valid()
        ) {
          @for (error of configForm.cartReservationWindowMinutes().errors(); track error.kind) {
            <small class="error">{{ error.message }}</small>
          }
        }
      </div>

      <div class="field">
        <label for="cartReservationLowTimeThresholdMinutes">Low-Time Threshold (minutes)</label>
        <p-inputNumber
          data-testid="orders-config-low-time"
          inputId="cartReservationLowTimeThresholdMinutes"
          [min]="0"
          [max]="configForm.cartReservationWindowMinutes().value()"
          [maxFractionDigits]="0"
          [showButtons]="true"
          [ngModel]="configForm.cartReservationLowTimeThresholdMinutes().value()"
          (ngModelChange)="configForm.cartReservationLowTimeThresholdMinutes().value.set($event)"
        />
        <small class="help-text">Remaining time at which the client offers the Extend action.</small>
        @if (
          configForm.cartReservationLowTimeThresholdMinutes().touched() &&
          !configForm.cartReservationLowTimeThresholdMinutes().valid()
        ) {
          @for (error of configForm.cartReservationLowTimeThresholdMinutes().errors(); track error.kind) {
            <small class="error">{{ error.message }}</small>
          }
        }
      </div>

      <div class="field">
        <label for="cartReservationExtensionMinutes">Extension (minutes)</label>
        <p-inputNumber
          data-testid="orders-config-extension"
          inputId="cartReservationExtensionMinutes"
          [min]="1"
          [max]="configForm.cartReservationWindowMinutes().value()"
          [maxFractionDigits]="0"
          [showButtons]="true"
          [ngModel]="configForm.cartReservationExtensionMinutes().value()"
          (ngModelChange)="configForm.cartReservationExtensionMinutes().value.set($event)"
        />
        <small class="help-text">How much time the Extend action adds to a live reservation.</small>
        @if (
          configForm.cartReservationExtensionMinutes().touched() &&
          !configForm.cartReservationExtensionMinutes().valid()
        ) {
          @for (error of configForm.cartReservationExtensionMinutes().errors(); track error.kind) {
            <small class="error">{{ error.message }}</small>
          }
        }
      </div>

      <div class="field toggle-field">
        <p-toggleswitch
          data-testid="orders-config-enabled"
          inputId="cartReservationEnabled"
          [ngModel]="configForm.cartReservationEnabled().value()"
          (ngModelChange)="configForm.cartReservationEnabled().value.set($event)"
        ></p-toggleswitch>
        <label for="cartReservationEnabled" class="toggle-label">Reservation feature enabled</label>
      </div>

      <div class="actions">
        <p-button
          data-testid="orders-config-save"
          label="Save"
          icon="pi pi-save"
          [loading]="saving()"
          [disabled]="configForm().invalid()"
          (onClick)="onSave()"
        />
      </div>
    }
  </p-card>
</div>
